<app-menu></app-menu>
<div class="erreur404">
  <div class="container">
    <!--    <div class="logo">-->
    <!--      <img src="{{'assets/logo/logo-default.svg'}}" alt="Logo The DoorMan">-->
    <!--    </div>-->
    <div class="titre">
    <!--      <p class="uppercase brand01default">erreur 404</p>-->
      <p class="regular-4xl-uppercase">Désolé, la page demandée n’existe pas, plus ou est momentanément indisponible</p>
    </div>
    <div class="causes">
      <p class="medium-3xl-uppercase">Quelques causes probables : </p>
      <ul>
        <li>Vous avez mal tapé l'URL dans la barre d'adresse</li>
        <li>Vous avez cliqué sur un lien menant vers une page qui n'existe plus</li>
        <li>Vous n'avez pas les droits suffisants pour accéder à cette page</li>
      </ul>
    </div>
    <div class="causes">
      <p class="medium-3xl-uppercase">Pour retrouver votre chemin... </p>
      <ul>
        <li>Nous vous conseillons de repasser par <a [href]="['/accueil']">l'accueil</a></li>
        <li>Vous pouvez aussi <a [href]="['/contact']" fragment="Nous-contacter">nous contacter</a> pour nous signaler
          cette erreur
        </li>
      </ul>
      <a [href]="['/accueil']" class="btn btn-primary">Retourner à l’accueil</a>
    </div>
  </div>
</div>
<app-footer></app-footer>
